import './_MemberShipItem.scss';

export const PLACEHOLDER = 'data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAEAAAABCAYAAAAfFcSJAAAADUlEQVQYV2N4+vTpfwAJEQOv0aXZiAAAAABJRU5ErkJggg==';

export const MembershipItemSkeleton = () => (
  <div className='membership-item membership-item--skeleton'>
    <img src={PLACEHOLDER} alt='asd' loading='lazy' />
  </div>
);
